const menuList = [
    {
        path: '/bigScreen',
        name: '大屏',
        component: () => import('@/views/bigScreen.vue'),
    },
    {
        path: "/webgl",
        name: "WebGL",
        component: () => import('@/views/webgl.vue'),
    },
    {
        path: "/canvasEffect",
        name: "特效",
        component: () => import('@/views/canvasEffect.vue'),
    },
    {
        path: "/siteCollect",
        name: "站点",
        component: () => import('@/views/siteCollect.vue'),
    },
    {
        path: "/otherSundry",
        name: "其它",
        component: () => import('@/views/otherSundry.vue'),
    },
]

export default menuList
